<button
  nbButton
  ghost
  status="primary"
  size="small"
  (click)="goBack()"
  class="back-button"
>
  <nb-icon icon="arrow-back-outline"></nb-icon>
  Back to Datasets
</button>

<div class="iframe-container">
  <iframe #iframe [src]="plotSrc" scrolling="no"></iframe>
</div>
